export { default } from "./dotsIndicator";
